import { Component, ViewChild, ElementRef } from '@angular/core'
import { Router } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component'
import { SharedService } from '../../services/shared.service'
import { HttpService } from '../../services/http.service'
import { Product } from '../../models/product'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'
import { OrderSummaryDialogComponent } from '../../dialogs/order-summary-dialog/order-summary-dialog.component'

@Component({
	selector: 'app-payment',
	templateUrl: './payment.component.html',
	styleUrls: ['./payment.component.css']
})
export class PaymentComponent {
	@ViewChild("cvv") cvv: ElementRef;

	product: Product
	form: FormGroup
	months = []
	years = []
	spinner: MatDialogRef<SpinnerDialogComponent>

	constructor(
		private router: Router,
		public shared: SharedService,
		public dialog: MatDialog,
		private formBuilder: FormBuilder,
		private http: HttpService,
	) {
		this.shared.blockRefresh()
		let card = this.shared.empty_card
		this.product = this.shared.product
		this.form = this.formBuilder.group({
			name: [
				'',
				Validators.required
			],
			postalCode: [
				{
					value: this.shared.user.postalCode,
					disabled: true
				},
				[Validators.required, Validators.pattern('^[0-9\-]*$')]
			],
			number: [
				card.number,
				[Validators.required, Validators.pattern('^[0-9\-]*$')]
			],
			securityCode: [
				card.securityCode,
			],
			expirationMonth: [
				card.expirationMonth,
				Validators.required
			],
			expirationYear: [
				card.expirationYear,
				Validators.required
			]
		})

		for (let i = 1; i < 13; i++) {
			let month: string = ''
			if (i < 10) month = '0' + i
			else month = '' + i
			this.months.push({ title: month, value: month })
		}

		let year = new Date().getFullYear()

		for (let i = 0; i < 12; i++) {
			let title: string = ''
			let value: string = '' + year
			// if (year % 100 == 0) title = '00'
			// else title = '' + (year % 100)
			title = '' + year
			this.years.push({ title: title, value: value })
			year++
		}

		/*
		this.http.getTax(this.shared.serialNumber, this.shared.user.postalCode, this.shared.user.country, this.shared.product)
			.subscribe((response) => {
				console.log(response.success)
				if (response.success == false) {
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: response.message,
							button: 'Close'
						}
					})
				} else {
					this.shared.price = response.data.subtotal.toFixed(2)
					this.shared.tax = response.data.totalTax.toFixed(2)
					this.shared.taxrate = response.data.taxRate.toFixed(2)
					this.shared.total = response.data.total.toFixed(2)
				}
			}, (error) => {
				this.spinner.close()
				this.dialog.open(
					MessageDialogComponent, {
					data: {
						title: '',
						description: error.message,
						button: 'Close'
					}
				})
			})
		*/
	}

	keyPressNumbersOnly(event: any) {
		this.shared.keyPressNumbersOnly(event)
	}

	keyPressAlphabetsOnly(event: any) {
		this.shared.keyPressAlphabetsOnly(event)
	}

	keyPressAlphaNumericOnly(event: any) {
		this.shared.keyPressAlphaNumericOnly(event)
	}

	keyPressAlphaNumericSpaceOnly(event: any) {
		this.shared.keyPressAlphaNumericSpaceOnly(event)
	}

	formatCreditCard(s: String): void {
		const value = s.replace(/[^0-9]/g, '')
		let format = '****-****-****-****'
		for (let i = 0; i < value.length; i++) format = format.replace('*', value.charAt(i));
		if (format.indexOf('*') >= 0) format = format.substring(0, format.indexOf('*'));
		this.form.value.number = format.trim()
		// this.form.value.number = '4266-8416-1658-2209' // visa
		// this.form.value.number = '3774-8121-6707-551' // amex
		if (this.form.value.number.length > 13) {
			let interval = setInterval(() => {
				const card = this.form.value.number.replace(/-/g, '')
				const visa = '^4[0-9]\{12}(?:[0-9]{3})?$'
				const master = '^5[1-5][0-9]{14}$'
				const amex = '^3[47][0-9]{13}$'
				const discover = '^6(?:011|5[0-9]{2})[0-9]{12}$'
				// const diners = '^3(?:0[0-5]|[68][0-9])[0-9]{11}$'
				// const jcb = '^(?:2131|1800|35\\d{3})d{11}$'

				if (card.match(visa) || card.match(master) || card.match(discover)) {
					this.cvv.nativeElement.setAttribute('maxLength', '3')
					this.form.controls.securityCode.setValidators([
						Validators.required,
						// Validators.maxLength(3),
						Validators.pattern('^[0-9]{3}$')
					])
				} else if (card.match(amex)) {
					this.cvv.nativeElement.setAttribute('maxLength', '4')
					this.form.controls.securityCode.setValidators([
						Validators.required,
						Validators.pattern('^[0-9]{4}$')
					])
				} else {
					this.cvv.nativeElement.setAttribute('maxLength', '4')
					this.form.controls.securityCode.setValidators(null)
				}
				this.form.controls.securityCode.updateValueAndValidity()
				clearInterval(interval)
			}, 1000)
		}
	}

	onPrevious(): void {
		this.router.navigateByUrl('/personal-info')
	}

	onNext(): void {
		this.form.value.number = this.form.value.number.replace(/-/g, '')
		this.shared.card = this.form.value
		this.dialog.open(OrderSummaryDialogComponent)
	}
}